export enum ChannelCodeType {
    UI = 'EdonusumUI'
}